import { gql } from "@apollo/client";

export const CREATE_SUPPLIER_COMPANY = gql`
  mutation CREATE_SUPPLIER_COMPANY(
    $supplierId: ID!
    $system: String!
    $odooPartnerId: Int!
  ) {
    createSupplierCompany(
      supplierId: $supplierId
      system: $system
      odooPartnerId: $odooPartnerId
    ) {
      supplier {
        id
        odooPartners {
          id
          company
          odooId
        }
      }
    }
  }
`;

export const DELETE_SUPPLIER_COMPANY = gql`
  mutation DELETE_SUPPLIER_COMPANY($supplierId: ID!, $supplierCompanyId: ID!) {
    deleteSupplierCompany(
      supplierId: $supplierId
      supplierCompanyId: $supplierCompanyId
    ) {
      supplier {
        id
        odooPartners {
          id
          company
          odooId
        }
      }
    }
  }
`;
